import React, { useState } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const InputTypeBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(props.rowData);

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    nextData['downtimedetail'] = null
    setData(nextData);
    props.persist(val, field, props.rowData)
  }

  const unnested_attrs = (field) => field_attrs('mosdowntime')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Downtime (Mos)</label>
          <NumberInput className="automated" data={data} attrs={unnested_attrs} field="mosdowntime" readPrecision={2} writePrecision={2} min={0} max={100} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default InputTypeBasic